<template>
    <div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title has-text-white">Input Company Rates</p>
                <button
                    type="button"
                    class="delete"
                    @click="$emit('close')"/>
            </header>
            <section class="modal-card-body has-background-dvodark">
                <b-field label="Labor Cost">
                    <b-input v-model="laborCost">
                    </b-input>
                </b-field>
                <b-field label="Landing %">
                    <b-input v-model="landingPercent">
                    </b-input>
                </b-field>
            </section>
            <footer class="modal-card-foot">
                <b-button class="is-dvogreen" @click=" $emit('refresh'); approveCompany(); $emit('close');" >Make Request</b-button>
            </footer>
        </div>
    </div>
</template>

<script>
import { API } from 'aws-amplify';
import { companyHandler, companyJobHandler, personCompanyRoleHandler } from '../graphql/mutations'
import { roleReader } from '../graphql/queries'

export default {
    data(){
    return{
        laborCost: null,
        landingPercent: null,
        id: this.initId,
        requesterId: this.initRequester,
        roles: []
        }
    },
    props: ['initId', 'initRequester'],
    methods:{
        async getRoles() {
                const roleHolder = await API.graphql({
                    query: roleReader,
                    variables:{
                        input: {
                            request_type: 'read_for_init_company'
                        }
                    }
                })

                this.roles = roleHolder.data.roleReader
                console.log(this.roles)
        },
        async approveCompany() {
                await API.graphql({
                    query: companyHandler,
                    variables: {
                        input: {
                            request_type: 'update_rates',
                            id: this.id,
                            labor_cost: this.laborCost,
                            landing_percent: this.landingPercent
                        }
                    }
                });

                await API.graphql({
                    query: companyHandler,
                    variables: {
                        input: {
                            id: this.id,
                            request_type: 'approve_company'
                        }
                    }
                });

                await API.graphql({
                    query: companyJobHandler,
                    variables: {
                        input: {
                            request_type: 'add',
                            company_id: this.id,
                            job_id: 3
                        }
                    }
                });

                await API.graphql({
                    query: companyJobHandler,
                    variables: {
                        input: {
                            request_type: 'add',
                            company_id: this.id,
                            job_id: 4
                        }
                    }
                });

                for(let i = 0; i < this.roles.length; i++){
                console.log('ROLE added: ' + this.roles[i])
                console.log('ROLES REMAINING' + (this.roles.length - i)) 
                await API.graphql({
                    query: personCompanyRoleHandler,
                    variables: {
                        input: {
                            request_type: 'add',
                            user_id: this.requesterId,
                            company_id:this.id,
                            role_id: this.roles[i].id
                        }
                    }
                })
 
                }    
            },
    },
    mounted(){
        this.getRoles();
    }
}
</script>
